import "bootstrap/dist/css/bootstrap.min.css";
import { onValue } from "firebase/database";
import { useEffect, useState } from "react";
import { fetchRequestsRef, updateRequest, deleteRequest } from "../firebaseHelpers";

const Requests = () => {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    const rRef = fetchRequestsRef();
    onValue(rRef, (snap) => {
      if (snap.exists()) {
        const list = Object.entries(snap.val()).map(([id, data]) => ({ id, ...data }));
        setRequests(list.reverse());
      } else {
        setRequests([]);
      }
    });
  }, []);

  const logged = JSON.parse(localStorage.getItem("loggedUser") || "null");
  if (!logged || logged.role !== "Admin") {
    return (
      <div className="container my-5 text-center">
        <h5>केवल Admin पहुँच कर सकते हैं।</h5>
      </div>
    );
  }

  const handleAction = async (id, action) => {
    if (action === "resolved") {
      await updateRequest(id, { status: "resolved" });
      alert("प्रार्थना को resolved किया गया ✅");
    } else if (action === "hold") {
      await updateRequest(id, { status: "hold" });
      alert("प्रार्थना को hold किया गया ✅");
    } else if (action === "approve") {
      await updateRequest(id, { status: "approved" });
      alert("प्रार्थना को मान्य किया गया ✅");
    } else if (action === "delete") {
      if (!window.confirm("क्या आप वाकई इस अनुरोध को Firebase से पूरी तरह हटाना चाहते हैं?")) return;
      await deleteRequest(id);
      alert("अनुरोध Firebase से हटा दिया गया ✅");
    }
  };

  return (
    <div className="container my-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white fw-bold text-center">📬 परिवार अनुरोध</div>
        <div className="card-body p-0">
          <table className="table table-striped table-bordered mb-0 text-center">
            <thead className="table-secondary">
              <tr>
                <th>#</th>
                <th>प्रकार</th>
                <th>Registration ID</th>
                <th>नाम</th>
                <th>फोन</th>
                <th>विवरण</th>
                <th>स्थिति</th>
                <th>निर्मित</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted">कोई अनुरोध नहीं</td>
                </tr>
              ) : (
                requests.map((r, i) => {
                  const isResolved = r.status === 'resolved';
                  return (
                    <tr key={r.id} style={isResolved ? { background: '#eee', color: '#888' } : {}}>
                      <td>{i + 1}</td>
                      <td>{r.type || "-"}</td>
                      <td>{r.regId || "-"}</td>
                      <td>{r.name || "-"}</td>
                      <td>{r.phone || "-"}</td>
                      <td style={{ maxWidth: 250, wordBreak: 'break-word' }}>
                        <div className="text-truncate" title={r.message || "-"}>
                          {r.message || "-"}
                        </div>
                      </td>
                      <td>
                        <span className={`badge ${r.status === 'pending' ? 'bg-warning text-dark' : r.status === 'resolved' ? 'bg-secondary' : 'bg-success'}`}>{r.status === 'pending' ? 'Pending' : r.status === 'resolved' ? 'Resolved' : r.status}</span>
                      </td>
                      <td>{new Date(r.createdAt).toLocaleString()}</td>
                      <td>
                        {r.status === 'pending' && (
                          <>
                            <button className="btn btn-sm btn-outline-success me-2" onClick={() => handleAction(r.id, "resolved")}>Resolved</button>
                          </>
                        )}
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleAction(r.id, "delete")}>🗑️ Delete</button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Requests;
